var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.to}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":""}}),_vm._v(" "+_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }